import {
  booleanPreferenceSelector,
  userNameSelector,
} from '../../auth/selectors/auth.selectors';
import { Diagnostic, DiagnosticProcessor } from '../types/diagnostic';

export const filterDiagnostics: DiagnosticProcessor = (
  diagnostics: Diagnostic[],
  getState,
): Diagnostic[] => {
  const userName = userNameSelector(getState()) ?? '';
  const showAlgoDiagnostic = booleanPreferenceSelector('showAlgoDiagnostic')(
    getState(),
  );

  const showCoworkerDiagnostic = booleanPreferenceSelector(
    'showCoworkerDiagnostic',
  )(getState());

  return diagnostics.filter(
    (diagnostic) =>
      diagnostic.expertName === userName ||
      (showAlgoDiagnostic && diagnostic.expertRole === 'algo') ||
      (showCoworkerDiagnostic && diagnostic.expertRole === 'user'),
  );
};

export const isDiagnosticEmpty = (diagnostic: Diagnostic) =>
  diagnostic.comment === '' && diagnostic.abnormalities.length === 0;
